import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "submitBtn"];
  static values = {
    amount: Number,
    paymentMethod: String,
    publicKey: String,
    txRef: String,
    redirectUrl: String,
    customerEmail: String,
    customerPhone: String,
    customerName: String,
  };

  connect() {}

  submit(event) {
    event.preventDefault();

    // Validate form
    if (!this.validateForm()) {
      return;
    }

    // Show loading state
    this.showLoading();

    // Submit form via fetch to create transaction
    this.createTransaction();
  }

  validateForm() {
    const amount = this.formTarget.querySelector("#transaction_amount").value;
    const paymentMethod = this.formTarget.querySelector(
      'input[name="transaction[payment_method]"]:checked'
    );

    if (!amount || parseFloat(amount) < 1000) {
      alert("Please enter a valid amount (minimum UGX 1,000)");
      return false;
    }

    if (!paymentMethod) {
      alert("Please select a payment method");
      return false;
    }

    return true;
  }

  showLoading() {
    this.submitBtnTarget.innerHTML = `
      <svg class="w-5 h-5 mr-2 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
      </svg>
      Processing...
    `;
    this.submitBtnTarget.disabled = true;
  }

  createTransaction() {
    const formData = new FormData(this.formTarget);

    fetch(this.formTarget.action, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Initialize Flutterwave payment
          this.initializeFlutterwavePayment(data);
        } else {
          alert("Transaction creation failed. Please try again.");
          this.resetButton();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("An error occurred. Please try again.");
        this.resetButton();
      });
  }

  initializeFlutterwavePayment(transactionData) {
    // Configure payment options based on selected method
    let paymentOptions = this.getPaymentOptions(transactionData.payment_method);

    const paymentConfig = {
      public_key: transactionData.public_key,
      tx_ref: transactionData.tx_ref,
      amount: parseFloat(transactionData.amount),
      currency: "UGX",
      payment_options: paymentOptions,
      redirect_url: transactionData.redirect_url,
      customer: transactionData.customer,
      meta: transactionData.meta,
      callback: (data) => this.handlePaymentCallback(data),
      onclose: () => this.handlePaymentClose(),
      customizations: {
        title: "Pension Deposit",
        description: "Secure your retirement future",
      },
    };

    FlutterwaveCheckout(paymentConfig);
  }

  getPaymentOptions(paymentMethod) {
    switch (paymentMethod) {
      case "mobile_money":
        return "mobilemoneyuganda";
      case "bank_transfer":
        return "banktransfer";
      case "card":
        return "card";
      default:
        return "card,mobilemoneyuganda,banktransfer";
    }
  }

  handlePaymentCallback(data) {
    if (data && data.transaction_id) {
      // Show success message
      alert("Payment submitted! Redirecting to transactions...");

      // Redirect to transactions index
      window.location.href = this.redirectUrlValue;
    } else {
      alert(
        `Payment status: ${data.status}. Please check your transactions page for updates.`
      );
      window.location.href = this.redirectUrlValue;
    }
  }

  handlePaymentClose() {
    console.log("Payment modal closed");
    this.resetButton();
  }

  resetButton() {
    this.submitBtnTarget.innerHTML = `
      <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
      </svg>
      Proceed to Payment
    `;
    this.submitBtnTarget.disabled = false;
  }
}
